import { isNil } from "lodash";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";

import { useDropdownSourceContext } from "@ryde/redux";
import { companyIdSelector, IDropdownItemExt } from "@ryde/shared";

import { isRoleFromOtherCompany } from "./table-user-roles.utils";

export const useIsUserRoleFromOtherCompany = (roleId?: number): boolean => {
  const companyId = useRecoilValue(companyIdSelector);
  const { getDropdownItems } = useDropdownSourceContext();
  const [isOtherCompanyRole, setIsOtherCompanyRole] = useState(false);

  useEffect(() => {
    let isCanceled = false;

    const checkUserRoleFromOtherCompany = async (): Promise<void> => {
      if (!roleId) {
        if (!isCanceled) {
          setIsOtherCompanyRole(false);
        }

        return;
      }

      const ownCompanyIdRaw = !isNil(companyId) ? Number(companyId) : NaN;

      if (Number.isNaN(ownCompanyIdRaw)) {
        if (!isCanceled) {
          setIsOtherCompanyRole(false);
        }

        return;
      }

      const items = (await getDropdownItems("role")) as IDropdownItemExt[];
      const roleItem = items?.find(
        item => Number(item.value) === Number(roleId),
      );

      if (!isCanceled) {
        setIsOtherCompanyRole(
          isRoleFromOtherCompany({
            roleCompanyId: roleItem?.companyId,
            ownCompanyId: ownCompanyIdRaw,
          }),
        );
      }
    };

    checkUserRoleFromOtherCompany();

    return () => {
      isCanceled = true;
    };
  }, [companyId, getDropdownItems, roleId]);

  return isOtherCompanyRole;
};
